import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { CheckIcon, XIcon, Trash2Icon } from 'lucide-react'
import { Button } from '../ui/button'
import MemberItem from './MemberItem'
import { BadgeType } from '../Badge/Badge'
import { AccountantConnection } from '../../types'

interface IProps {
  connection: AccountantConnection
  onAccept: (connection: AccountantConnection) => void
  onRemove: (connection: AccountantConnection) => void
}

export default function AccountantConnectionItem({ connection, onAccept, onRemove }: IProps) {
  const { t } = useTranslation()
  const { accountant, status, initiated_by } = connection
  const isRequest = status === 'pending' && initiated_by === 'accountant'
  const isInvite = status === 'pending' && initiated_by === 'workspace'

  const fullName = accountant?.first_name || accountant?.last_name ? accountant.full_name : null
  const name = fullName || connection.email

  const badge: { type: BadgeType, text: string } = isRequest
    ? { type: 'warning', text: t('Team::Request pending') }
    : isInvite
      ? { type: 'warning', text: t('Team::Invited') }
      : { type: 'success', text: t('Team::Connected') }

  return (
    <MemberItem
      name={name}
      role={accountant?.company_name}
      subheading={fullName ? connection.email : undefined}
      badge={badge}
      actions={
        <>
          {isRequest && (
            <Button variant='outline' size='sm' onClick={() => onAccept(connection)}>
              <CheckIcon data-icon='inline-start' />
              {t('Team::Accept')}
            </Button>
          )}
          {status === 'accepted' ? (
            <Button variant='destructive' size='sm' onClick={() => onRemove(connection)}>
              <Trash2Icon data-icon='inline-start' />
              {t('Team::Remove')}
            </Button>
          ) : (
            <Button variant='outline' size='sm' onClick={() => onRemove(connection)}>
              <XIcon data-icon='inline-start' />
              {isRequest ? t('Team::Decline') : t('Team::Cancel invitation')}
            </Button>
          )}
        </>
      }
    />
  )
}
